import { AfterContentInit, Component, EventEmitter, Output } from '@angular/core';
import { BaseProjectComponent } from '@layouts/default/layouts/logged/pages/project/components/base-project.component';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-sort-ranking',
  templateUrl: './sort-ranking.component.html',
  styleUrls: ['./sort-ranking.component.scss'],
})
export class SortRankingComponent extends BaseProjectComponent implements AfterContentInit {
  form: UntypedFormGroup = new UntypedFormGroup({});
  @Output() changeSort: EventEmitter<any> = new EventEmitter();

  constructor() {
    super();
  }

  ngAfterContentInit() {
    setTimeout(() => {
      this.form.get('ranking_sort').setValue(this.route.snapshot.queryParams.ranking);
    }, 100);
  }

  changeSortRank(event) {
    this.changeSort.emit(event.value);
  }
}
